const BANDWIDTH_PROVIDERS = ['Bandwidth', 'Bandwidth UP']
const TELNYX_PROVIDER = 'Telnyx'
const VOIP_INNOVATIONS_PROVIDER = 'Voip Innovations'

const VOIP_INNOVATIONS_URL =
  'https://backoffice.voipinnovations.com/DIDs/Management.aspx'

/**
 * Construct a portal URL for a phone number's provider.
 *
 * Mirrors the logic in mango-api's PhoneNumber model
 * (`voice_provider_url` / `sms_provider_url` properties).
 *
 * Bandwidth links require the dashboard account ID. Pass `undefined`
 * until the value is available; the function will return `undefined`
 * in that case.
 */
export function getProviderUrl(
  providerName: string | null | undefined,
  remoteId: string | null | undefined,
  phoneNumber: string | null | undefined,
  bandwidthAccountId?: string,
): string | undefined {
  if (!providerName) return undefined

  if (BANDWIDTH_PROVIDERS.includes(providerName)) {
    if (!bandwidthAccountId || !phoneNumber) return undefined
    return `https://dashboard.bandwidth.com/portal/r/a/${bandwidthAccountId}/numbers/details/${phoneNumber}`
  }

  if (providerName === TELNYX_PROVIDER) {
    if (!remoteId) return undefined
    return `https://portal.telnyx.com/#/numbers/my-numbers/${remoteId}`
  }

  if (providerName === VOIP_INNOVATIONS_PROVIDER) {
    return VOIP_INNOVATIONS_URL
  }

  return undefined
}
